/*@ngInject*/
module.exports = function($rootScope, publicUsersService, $q) {
	return {
		scope: {
            userId: '@'
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function() {
			const vm = this;
			vm.rootScope = $rootScope;
			vm.passesError = false;
			vm.updateUserProfileError = false;
			vm.updateUserProfileErrorMessage = '';
			vm.updateUserProfileSuccess = false;
			vm.updateUserProfileSuccessMessage = '';

			const currentUser = vm.rootScope.getCurrentUser();

			vm.userEmail = currentUser.email;
			vm.viewMode = 'user';
				vm.user = {
					id: currentUser.id,
					firstname: currentUser.firstname,
					lastname: currentUser.lastname,
					pass: '',
					pass1: '',
					pass2: ''
				};

			vm.canChangePassword = currentUser.authentication_method === 'EMAIL';
			vm.passwordPattern = publicUsersService.passwordPattern;

			vm.back = () => {
				vm.viewMode = 'user';
				vm.passesError = false;
				vm.user.pass = vm.user.pass1 = vm.user.pass2 = '';
			};

			vm.isPasswordRequired = () => {
				return !!(vm.user.pass || vm.user.pass1 || vm.user.pass2);
			};

			const validateForm = () => {
				return $q(function(resolve, reject) {
					vm.showErrors = false;
					vm.isConfirmedPassIncorrect();
					if (vm.userProfileForm.$invalid || vm.passesError) {
						vm.showErrors = true;
						reject();
					} else {
						resolve();
					}
				});
			};

			vm.isConfirmedPassIncorrect = () => {
				if (vm.user.pass1 && vm.user.pass2) {
					vm.passesError = (vm.user.pass1 !== vm.user.pass2);
				}
			};

			vm.changePassword = () => vm.viewMode = 'pass';

			vm.save = () => {
				vm.updateUserProfileError = false;
				vm.updateUserProfileError = false;
				vm.passwordChanged = !!vm.user.pass;
				validateForm().then(function() {
					publicUsersService.updatePublicUser(vm.user).then((response) => {
						if (response.data === 'ok') {
							vm.back();
							vm.updateUserProfileSuccess = true;
							vm.updateUserProfileSuccessMessage = vm.passwordChanged ? 'password_changed' : 'data_updated';
						}
						else {
							vm.updateUserProfileError = true;
							vm.updateUserProfileErrorMessage = response.data === 'nok' ? 'profile_data_update_error' : response.data;
						}
					});
				});
			};
		},
		template: require('./user-profile.html')
	};
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/user-profile.directive.js
 **/